"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDashboardEventOrCustomDashboardEvent = exports.isCustomDashboardEvent = exports.isDashboardEvent = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2023 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Tests whether object is an instance of {@link IDashboardEvent}.
 *
 * @param obj - object to test
 * @public
 */
function isDashboardEvent(obj) {
    var _a;
    return !isEmpty_1.default(obj) && ((_a = obj.type) === null || _a === void 0 ? void 0 : _a.startsWith("GDC.DASH/EVT"));
}
exports.isDashboardEvent = isDashboardEvent;
/**
 * Tests whether object is an instance of {@link ICustomDashboardEvent}.
 *
 * @param obj - object to test
 * @public
 */
function isCustomDashboardEvent(obj) {
    var _a;
    return !isEmpty_1.default(obj) && ((_a = obj.type) === null || _a === void 0 ? void 0 : _a.startsWith("CUSTOM/EVT"));
}
exports.isCustomDashboardEvent = isCustomDashboardEvent;
/**
 * Tests whether object is an instance of {@link IDashboardEvent} or {@link ICustomDashboardEvent}.
 *
 * @param obj - object to test
 * @public
 */
function isDashboardEventOrCustomDashboardEvent(obj) {
    return isDashboardEvent(obj) || isCustomDashboardEvent(obj);
}
exports.isDashboardEventOrCustomDashboardEvent = isDashboardEventOrCustomDashboardEvent;
//# sourceMappingURL=base.js.map